// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!./bivariate-choropleth.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!./coxcomb.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js!./flow.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../node_modules/css-loader/dist/cjs.js!./pie.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../../node_modules/css-loader/dist/cjs.js!./spike.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../../node_modules/css-loader/dist/cjs.js!./ternary.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../../node_modules/css-loader/dist/cjs.js!./spark.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.em-legend-background {
    fill: white;
    opacity: 0.9;
    rx: 0;
    ry: 0;
    pointer-events: none;
}

/* titles */
.em-legend-title {
    font-weight: bold;
    font-size: 15px;
    fill: #4c4b4b;
}

.em-size-legend-title {
    font-size: 15px;
    fill: #666;
    font-weight: bold;
}

.em-color-legend-title {
    font-size: 15px;
    fill: #696969;
    font-weight: bold;
}

.em-width-legend-title {
    font-size: 15px;
    fill: #696969;
    font-weight: bold;
}

.em-time-legend-title {
    font-size: 15px;
    fill: #666;
    font-weight: bold;
}

.em-legend-subtitle {
    font-size: 15px;
    fill: #696969;
    opacity: 0.8;
}

/* labels */
.em-legend-label {
    font-size: 14px;
    stroke: none;
    fill: #5e5e5e;
    dominant-baseline: unset;
}

.em-legend-label-max,
.em-legend-label-min,
.em-legend-label-no-data {
    fill: #707070;
}

.em-legend-label-max:hover,
.em-legend-label-min:hover,
.em-legend-label-no-data:hover {
    font-weight: bold;
}

/* ticks */
.em-legend-tick {
    stroke: #696969;
    stroke-width: 1;
}

/* swatch separator */
.em-legend-separator {
    stroke: #696969;
    stroke-width: 1;
}

/* cursor: pointer */
.em-legend-gradient {
    cursor: pointer;
}
.em-bivariate-square,
.em-legend-rect {
    cursor: pointer;
}
.em-legend-histogram-bar {
    cursor: pointer;
}

/* hover */
.em-bivariate-square:hover,
.em-legend-rect:hover {
    stroke-width: 2;
    stroke: red;
}

.em-legend-diverging-line {
    stroke: #696969;
    stroke-width: 1;
}
.em-legend-background {
    filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.5));
    opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./src/css/legend/legend.css"],"names":[],"mappings":"AAQA;IACI,WAAW;IACX,YAAY;IACZ,KAAK;IACL,KAAK;IACL,oBAAoB;AACxB;;AAEA,WAAW;AACX;IACI,iBAAiB;IACjB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,YAAY;AAChB;;AAEA,WAAW;AACX;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,wBAAwB;AAC5B;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;;;IAGI,iBAAiB;AACrB;;AAEA,UAAU;AACV;IACI,eAAe;IACf,eAAe;AACnB;;AAEA,qBAAqB;AACrB;IACI,eAAe;IACf,eAAe;AACnB;;AAEA,oBAAoB;AACpB;IACI,eAAe;AACnB;AACA;;IAEI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA,UAAU;AACV;;IAEI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;AACA;IACI,mDAAmD;IACnD,YAAY;AAChB","sourcesContent":["@import 'bivariate-choropleth.css';\n@import 'coxcomb.css';\n@import 'flow.css';\n@import 'pie.css';\n@import 'spike.css';\n@import 'ternary.css';\n@import 'spark.css';\n\n.em-legend-background {\n    fill: white;\n    opacity: 0.9;\n    rx: 0;\n    ry: 0;\n    pointer-events: none;\n}\n\n/* titles */\n.em-legend-title {\n    font-weight: bold;\n    font-size: 15px;\n    fill: #4c4b4b;\n}\n\n.em-size-legend-title {\n    font-size: 15px;\n    fill: #666;\n    font-weight: bold;\n}\n\n.em-color-legend-title {\n    font-size: 15px;\n    fill: #696969;\n    font-weight: bold;\n}\n\n.em-width-legend-title {\n    font-size: 15px;\n    fill: #696969;\n    font-weight: bold;\n}\n\n.em-time-legend-title {\n    font-size: 15px;\n    fill: #666;\n    font-weight: bold;\n}\n\n.em-legend-subtitle {\n    font-size: 15px;\n    fill: #696969;\n    opacity: 0.8;\n}\n\n/* labels */\n.em-legend-label {\n    font-size: 14px;\n    stroke: none;\n    fill: #5e5e5e;\n    dominant-baseline: unset;\n}\n\n.em-legend-label-max,\n.em-legend-label-min,\n.em-legend-label-no-data {\n    fill: #707070;\n}\n\n.em-legend-label-max:hover,\n.em-legend-label-min:hover,\n.em-legend-label-no-data:hover {\n    font-weight: bold;\n}\n\n/* ticks */\n.em-legend-tick {\n    stroke: #696969;\n    stroke-width: 1;\n}\n\n/* swatch separator */\n.em-legend-separator {\n    stroke: #696969;\n    stroke-width: 1;\n}\n\n/* cursor: pointer */\n.em-legend-gradient {\n    cursor: pointer;\n}\n.em-bivariate-square,\n.em-legend-rect {\n    cursor: pointer;\n}\n.em-legend-histogram-bar {\n    cursor: pointer;\n}\n\n/* hover */\n.em-bivariate-square:hover,\n.em-legend-rect:hover {\n    stroke-width: 2;\n    stroke: red;\n}\n\n.em-legend-diverging-line {\n    stroke: #696969;\n    stroke-width: 1;\n}\n.em-legend-background {\n    filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.5));\n    opacity: 0.9;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
